import { animate, keyframes, style, transition, trigger } from '@angular/animations';

export const reboundAnimation = [
    trigger('reboundIn', [
        transition(':enter', [
            animate('600ms cubic-bezier(0.175, 0.885, 0.32, 1.275)', keyframes([
                style({ transform: 'scale(0)', opacity: 0, offset: 0 }),
                style({ transform: 'scale(1.2)', opacity: 1, offset: 0.5 }),
                style({ transform: 'scale(0.9)', offset: 0.75 }),
                style({ transform: 'scale(1)', offset: 1 })
            ]))
        ])
    ])
];
